<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import { viewPDF } from '@/utils/sales-order';
import DateRangePicker from "daterangepicker";
import { productionUsers, approverUsers } from '@/utils/user';
import StatusBadge from '@/components/common/sales-order-status-badge.vue';
import { Modal } from 'bootstrap';

export default {
  inject: ['setLoading'],
  components: {
   StatusBadge 
  },
  data() {
    return {
      tableColumns: [
  { key: 'so_number', label: 'SO No' },
  { key: 'status', label: 'Status' },
  { key: 'type', label: 'Type' },
  { key: 'client_name', label: 'Client Name' },
  { key: 'client_phone', label: 'Client Phone' },
  { key: 'created_by', label: 'Created By' },
  { key: 'drawing_remark', label: 'Drawing Remark' },
  { key: 'approver_remark', label: 'Approver Remark' },
  { key: 'production_status', label: 'Production Status' },
  { key: 'client_action', label: 'Client Action' },
  { key: 'finance_action', label: 'Finance Action' }, 
  { key: 'advance_amount', label: 'Advance Amount' },
  { key: 'date', label: 'Date' },
  { key: 'actions', label: 'Actions' },
],
      title: "Finance & Accounts",
      text: "Finance & Accounts",
      data: [],
      users: [],
      expandedRows: [],
      rowRevisions: {},
      loadingRevisions: {},
      drawingUsers: [],
      app_currency: '',
      status_data: [],
      pagination: {
       current_page: 1,
       per_page: 25,
       last_page: 1,
       total: 0,
       links: []
      },
      selectedOrderDetail: null,
      filter: {
       status: '', 
       to_date: '',
       from_date: '',
       search_keyword: '',
       user_id: '',
      },
      loading: false,
      module_url: 'sales-orders',
      currentDimension: null,
      currentSalesOrderId: null,
      currentItemName: '',
      drawingDimensionForm: {
        drawing_width: null,
        drawing_height: null,
        drawing_quantity: null,
      },
    };
  },

computed: {
hasAnyDimensions() {
  return this.selectedOrderDetail?.sales_order_items?.some(
    item => item.dimensions && item.dimensions.length
  );
},

  text1(){
    return `Sales Orders (${this.pagination.total})`;
  },
  shouldMaskClientInfo() {
    const role = this.auth?.role;
    return role?.is_sales_order_drawing ||
          role?.is_sales_order_production ||
          role?.is_sales_order_cutting ||
          role?.is_sales_order_bending ||
          role?.is_sales_order_fabrication ||
          role?.is_sales_order_powder_coating ||
          role?.is_sales_order_packaging ||
          this.auth?.is_finance_user;
  },
  visibleColumns() {
  let columns = [...this.tableColumns];

  // Drawing user
  if (this.auth?.role?.is_sales_order_drawing) {
    return columns.filter(c => 
      c.key !== 'approver_remark' && 
      c.key !== 'advance_amount'
    );
  }

  // Finance user - SUB_ADMIN but no sales order role AND is_finance_user
  if (this.auth?.is_finance_user) {
    return columns.filter(c => 
      c.key !== 'drawing_remark' &&
      c.key !== 'finance_action'  
    );
  }

  // Admin 
  return columns.filter(c => 
    c.key !== 'drawing_remark' && 
    c.key !== 'advance_amount'
  );  
},
},

  async mounted(){
   this.getUsers(); 
   this.app_currency = await this.$appCurrency();
   this.filter.status = this.$route.query.status || '';
   this.loadAll();

   const start = moment().subtract(29, "days");
   const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );
    // Initialize filter date range as soon as picker mounts
    //this.setDateRange(start, end);
    
  }, 

  methods: {

    openDrawingDimensionModal(item, dim) {
  this.currentDimension = dim;
  this.currentSalesOrderId = this.selectedOrderDetail.id;
  this.currentItemName = item.name;
  this.drawingDimensionForm = {
    drawing_width: dim.drawing_width ?? null,
    drawing_height: dim.drawing_height ?? null,
    drawing_quantity: dim.drawing_quantity ?? null,
  };

  const modalEl = document.getElementById('drawing_dimension_modal');
  let modal = Modal.getInstance(modalEl);
  if (!modal) { modal = new Modal(modalEl); }
  modal.show();
},

async saveDrawingDimension() {
  this.setLoading(true);
  try {
    await axios.put(
      `/${this.module_url}/${this.currentSalesOrderId}/${this.currentDimension.id}/drawing-dimension`,
      {
        drawing_width: this.drawingDimensionForm.drawing_width,
        drawing_height: this.drawingDimensionForm.drawing_height,
        drawing_quantity: this.drawingDimensionForm.drawing_quantity,
      }
    );

    this.$swalToast('Drawing dimension saved successfully!', 'success');
    this.$closeModal('drawing_dimension_modal');

    // Update local dimension so icon turns green instantly
    this.currentDimension.drawing_width = this.drawingDimensionForm.drawing_width;
    this.currentDimension.drawing_height = this.drawingDimensionForm.drawing_height;
    this.currentDimension.drawing_quantity = this.drawingDimensionForm.drawing_quantity;

  } catch (error) {
    this.$swalToast(error.response?.data?.message || 'Failed to save drawing dimension', 'error');
  } finally {
    this.setLoading(false);
  }
},

    async approveFinanceAction(row) {
  const { value: formValues } = await this.$swal.fire({
    title: 'Approve Finance Action',
    html: ` 
      <div class="mb-3">
        <label class="form-label fw-semibold">Remark </label>
        <textarea id="approveFinanceRemark" class="form-control" rows="3" placeholder="Enter remark..."></textarea>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Approve',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#198754',
    didOpen: () => {
      setTimeout(() => {
        document.getElementById('approveFinanceRemark').focus();
      }, 100);
    },
    preConfirm: () => {
      const remark = document.getElementById('approveFinanceRemark').value.trim();
      return { remark, id: row.id };
    }
  });

  if (formValues) {
    await this.saveApproveFinanceAction(formValues);
  }
},

async saveApproveFinanceAction(formValues) {
  this.setLoading(true);
  try {
    await axios.post(`/${this.module_url}/${formValues.id}/approve-finance-action`, {
      remark: formValues.remark
    });
    this.$swalToast('Finance action approved successfully!', 'success');
    await this.loadAll();
  } catch (error) {
    this.$swalToast(error.response?.data?.message || 'Failed to approve finance action', 'error');
  } finally {
    this.setLoading(false);
  }
},

    async notifyFinance(row) {
      this.setLoading(true);
      try {
        await axios.get(`/${this.module_url}/${row.id}/notify-finance`);
        this.$swalToast('Finance approver notified successfully!', 'success');
      } catch (error) {
        this.$swalToast(error.response?.data?.message || 'Failed to notify finance approver', 'error');
      } finally {
        this.setLoading(false);
      }
    },

    async assignToApprover(row) {
  try {
    this.setLoading(true);
    const response = await approverUsers();
    const approvers = response.data.data;
    this.setLoading(false);

    const { value: formValues } = await this.$swal.fire({
      title: 'Assign to Approver',
      html: `
        <div class="mb-3">
          <label class="form-label fw-semibold">Select Approver <span class="text-danger">*</span></label>
          <select id="approverSelect" class="form-select">
            <option value="">Choose Approver</option>
            ${approvers.map(u => `<option value="${u.id}">${u.name}</option>`).join('')}
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label fw-semibold">Remark </label>
          <textarea id="approverRemark" class="form-control" rows="3" 
            placeholder="Enter remark..."></textarea>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Assign',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#198754',
      didOpen: () => {
        setTimeout(() => {
          document.getElementById('approverSelect').focus();
        }, 100);
      },
      preConfirm: () => {
        const approverId = document.getElementById('approverSelect').value;
        const remark = document.getElementById('approverRemark').value.trim();

        if (!approverId) {
          this.$swal.showValidationMessage('Please select an approver');
          return false;
        }
        return { 
          approver_id: approverId, 
          remark, 
          id: row.id 
        };
      }
    });

    if (formValues) {
      await this.saveAssignApprover(formValues);
    }
  } catch (error) {
    this.$swalToast(error.message, 'error');
    this.setLoading(false);
  }
},

async saveAssignApprover(formValues) {
  this.setLoading(true);
  try {
    await axios.patch(`/${this.module_url}/${formValues.id}/assign-approver`, {
      approved_by: formValues.approver_id, 
      remark: formValues.remark
    });
    this.$swalToast('Assigned to approver successfully!', 'success');
    await this.loadAll();
  } catch (error) {
    this.$swalToast(
      error.response?.data?.message || 'Failed to assign approver', 
      'error'
    );
  } finally {
    this.setLoading(false);
  }
},

  async sendDrawingReviewMail(row) {
  const result = await this.$confirm({
    title: 'Send Drawing Review Mail?',
    text: `Mail will be sent to ${row.email || row.party?.email} for drawing review.`,
  });
  
  if (!result.isConfirmed) return;
  
  this.setLoading(true);
  try {
    await axios.post(`/${this.module_url}/${row.id}/email`, {
      to_email: row.email || row.party?.email,
      mail_subject: `Sales Order #${row.so_number} - Drawing Ready for Review`,
      mail_body: `Dear ${row.party?.name || row.name || 'Customer'},<br><br>Your sales order drawing is ready for review. Please review and approve or reject it.<br><br><a href="${window.location.origin}/sales-orders/drawing-documents/${row.public_token}" style="display:inline-block;padding:10px 20px;background:#2563eb;color:#fff;text-decoration:none;border-radius:6px;font-weight:600;">Review Drawing</a>`,
      mail_footer: 'Thank you.'
    });
    this.$swalToast('Drawing review mail sent successfully!', 'success');
    await this.loadAll();
  } catch (error) {
    this.$swalToast(error?.response?.data?.message || 'Failed to send mail', 'error');
  } finally {
    this.setLoading(false);
  }
},

    async toggleRevisions(row) {
  const id = row.id;
  const i = this.expandedRows.indexOf(id);

  // Already expanded → collapse
  if (i !== -1) {
    this.expandedRows.splice(i, 1);
    return;
  }

  // Expand
  this.expandedRows.push(id);

  if (this.rowRevisions[id]) return;

  // Fetch revisions via byToken 
  this.loadingRevisions = { ...this.loadingRevisions, [id]: true };
  try {
    const response = await axios.get(`/${this.module_url}/${row.public_token}`);
    this.rowRevisions = { ...this.rowRevisions, [id]: response.data.data.revisions || [] };
  } catch (e) {
    this.rowRevisions = { ...this.rowRevisions, [id]: [] };
    this.$swalToast('Failed to load revisions', 'error');
  } finally {
    this.loadingRevisions = { ...this.loadingRevisions, [id]: false };
  }
},

isExpanded(id) {
  return this.expandedRows.includes(id);
},

async dispatchOrder(row) {
  if (!row.delivery_challan) {
    this.$swalToast('Delivery Challan not created yet. Please contact the Store Person.', 'error');
    return;
  }
  const { value: formValues } = await this.$swal.fire({
    title: 'Dispatch Order',
    html: `
      <div class="mb-3">
        <label class="form-label fw-semibold">Vehicle Number <span class="text-danger">*</span></label>
        <input type="text" id="vehicleNumber" class="form-control" placeholder="Enter vehicle number" value="${row.vehicle_number || ''}" />
      </div>
      <div class="mb-3">
        <label class="form-label fw-semibold">Driver Name <span class="text-danger">*</span></label>
        <input type="text" id="driverName" class="form-control" placeholder="Enter driver name" value="${row.driver_name || ''}" />
      </div>
      <div class="mb-3">
        <label class="form-label fw-semibold">Driver Contact No <span class="text-danger">*</span></label>
        <input type="text" id="driverContact" class="form-control" placeholder="Enter driver contact number" value="${row.driver_contact || ''}" />
      </div>
      <div class="mb-3">
        <label class="form-label fw-semibold">Remark </label>
        <textarea id="dispatchRemark" class="form-control" rows="3" placeholder="Enter dispatch remark..."></textarea>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Dispatch',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#198754',
    didOpen: () => {
      setTimeout(() => { document.getElementById('vehicleNumber').focus(); }, 100);
    },
    preConfirm: () => {
      const vehicleNumber = document.getElementById('vehicleNumber').value.trim();
      const driverName = document.getElementById('driverName').value.trim();
      const driverContact = document.getElementById('driverContact').value.trim();
      const remark = document.getElementById('dispatchRemark').value.trim();

      if (!vehicleNumber) {
        this.$swal.showValidationMessage('Please enter vehicle number');
        return false;
      }
      if (!driverName) {
        this.$swal.showValidationMessage('Please enter driver name');
        return false;
      }
      if (!driverContact) {
        this.$swal.showValidationMessage('Please enter driver contact number');
        return false;
      }
      if (!/^\d{10}$/.test(driverContact)) {
        this.$swal.showValidationMessage('Please enter a valid 10-digit contact number');
        return false;
      }
      return { 
        vehicle_number: vehicleNumber, 
        driver_name: driverName, 
        driver_contact: driverContact, 
        remark, 
        id: row.id 
      };
    }
  });

  if (!formValues) return;
  this.setLoading(true);
  try {
    await axios.post(`/${this.module_url}/${formValues.id}/dispatch`, {
      vehicle_number: formValues.vehicle_number,
      driver_name: formValues.driver_name,
      driver_contact: formValues.driver_contact,
      remark: formValues.remark
    });
    this.$swalToast('Order dispatched successfully!', 'success');
    await this.loadAll();
  } catch(error) {
    this.$swalToast(error?.message || 'Failed to dispatch', 'error');
  } finally {
    this.setLoading(false);
  }
},

    async createDeliveryChallan(row) {
  try {
    this.setLoading(true);

    const response = await axios.get(`/${this.module_url}/${row.id}/edit`);
    const salesOrder = response.data.data;
    this.setLoading(false);

    
    await this.$refs.challanModal.createFromSalesOrder(salesOrder);

    // Modal open karo
    this.$openModal('challan_modal');
  } catch(error) {
    this.$swalToast(error.message, 'error');
    this.setLoading(false);
  }
},


    async assignStorePerson(row) {
  try {
    this.setLoading(true);
    const response = await axios.get('/store-persons/dropdown');
    const storePersons = response.data.data;
    this.setLoading(false);

    const { value: formValues } = await this.$swal.fire({
      title: 'Assign Store Person',
      html: `
        <div class="mb-3">
          <label class="form-label fw-semibold">Select Store Person <span class="text-danger">*</span></label>
          <select id="storePersonSelect" class="form-select">
            <option value="">Choose Store Person</option>
            ${storePersons.map(u => `<option value="${u.id}">${u.user?.name}</option>`).join('')}
          </select>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Assign',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#198754',
      didOpen: () => {
        setTimeout(() => { document.getElementById('storePersonSelect').focus(); }, 100);
      },
      preConfirm: () => {
        const storePersonId = document.getElementById('storePersonSelect').value;
        if (!storePersonId) {
          this.$swal.showValidationMessage('Please select a store person');
          return false;
        }
        return { store_person_id: storePersonId, id: row.id };
      }
    });

    if (formValues) {
      await this.saveAssignStorePerson(formValues);
    }
  } catch(error) {
    this.$swalToast(error.message, 'error');
    this.setLoading(false);
  }
},

async saveAssignStorePerson(formValues) {
  this.setLoading(true);
  try {
    await axios.patch(`/${this.module_url}/${formValues.id}/assign-store-person`, {
      store_person_id: formValues.store_person_id
    });
    this.$swalToast('Store person assigned successfully!', 'success');
    await this.loadAll();
  } catch(error) {
    this.$swalToast(error.response?.data?.message || 'Failed to assign store person', 'error');
  } finally {
    this.setLoading(false);
  }
},

async assignToDispatch(row) {
  try {
    this.setLoading(true);
    const response = await axios.get('/users/dispatch');
    const dispatchUsers = response.data.data;
    this.setLoading(false);

    const { value: formValues } = await this.$swal.fire({
      title: 'Assign to Dispatch',
      html: `
        <div class="mb-3">
          <label class="form-label fw-semibold">Select Dispatch User <span class="text-danger">*</span></label>
          <select id="dispatchUser" class="form-select">
            <option value="">Choose Dispatch User</option>
            ${dispatchUsers.map(u => `<option value="${u.id}">${u.name}</option>`).join('')}
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label fw-semibold">Remark </label>
          <textarea id="dispatchRemark" class="form-control" rows="3" placeholder="Enter remark..."></textarea>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Assign',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#198754',
      didOpen: () => {
        setTimeout(() => { document.getElementById('dispatchRemark').focus(); }, 100);
      },
      preConfirm: () => {
        const userId = document.getElementById('dispatchUser').value;
        const remark = document.getElementById('dispatchRemark').value.trim();
        if (!userId) {
          this.$swal.showValidationMessage('Please select a dispatch user');
          return false;
        }
        return {
          assigned_to: userId,
          remark,
          id: row.id
        };
      }
    });

    if (formValues) {
      await this.saveAssignDispatch(formValues);
    }
  } catch(error) {
    this.$swalToast(error.message, 'error');
    this.setLoading(false);
  }
},

async saveAssignDispatch(formValues) {
  this.setLoading(true);
  try {
    await axios.post(`/${this.module_url}/${formValues.id}/assign-to-dispatch`, {
      assigned_to: formValues.assigned_to,
      remark: formValues.remark
    });
    this.$swalToast('Assigned to dispatch successfully!', 'success');
    await this.loadAll();
  } catch(error) {
    this.$swalToast(error.response?.data?.message || 'Failed to assign dispatch', 'error');
  } finally {
    this.setLoading(false);
  }
},

async completeStage(row) {
const stageConfig = {
  is_sales_order_production:     { stage: 'production',     usersApi: '/users/cutting',        label: 'Cutting' },
  is_sales_order_cutting:        { stage: 'cutting',        usersApi: '/users/bending',        label: 'Bending' },
  is_sales_order_bending:        { stage: 'bending',        usersApi: '/users/fabrication',    label: 'Fabrication' },
  is_sales_order_fabrication:    { stage: 'fabrication',    usersApi: '/users/powder-coating', label: 'Powder Coating' },
  is_sales_order_powder_coating: { stage: 'powder_coating', usersApi: '/users/packaging',      label: 'Packaging' },
  is_sales_order_packaging:      { stage: 'packaging',      usersApi: null,                    label: 'Complete' },
};

  const activeRole = Object.keys(stageConfig).find(role => this.auth?.role?.[role]);
  if (!activeRole) return;

  const config = stageConfig[activeRole];
  const isLastStage = config.usersApi === null;
  const isProductionStage = config.stage === 'production'; // <-- production stage check

  try {
    this.setLoading(true);
    let nextUsers = [];
    let storePersons = [];

    if (!isLastStage) {
      const response = await axios.get(config.usersApi);
      nextUsers = response.data.data;
    }

    // Production stage pe store person bhi fetch karo
    if (isProductionStage && !row.store_person_id) {
      const spRes = await axios.get('/store-persons/dropdown');
      storePersons = spRes.data.data;
    }

    this.setLoading(false);

    const { value: formValues } = await this.$swal.fire({
      title: `Assign to ${config.label}`,
      html: `
      ${!isLastStage ? `
      <div class="mb-3">
        <label class="form-label fw-semibold">Select ${config.label} User <span class="text-danger">*</span></label>
        <select id="nextStageUser" class="form-select">
          <option value="">Choose ${config.label} User</option>
          ${nextUsers.map(u => `<option value="${u.id}">${u.name}</option>`).join('')}
        </select>
      </div>` : ''}

      ${isProductionStage && !row.store_person_id ? `
      <div class="mb-3">
        <label class="form-label fw-semibold">Select Store Person <span class="text-danger">*</span></label>
        <select id="storePersonSelect" class="form-select">
          <option value="">Choose Store Person</option>
          ${storePersons.map(u => `<option value="${u.id}">${u.user?.name}</option>`).join('')}
        </select>
      </div>` : ''}

      <div class="mb-3">
        <label class="form-label fw-semibold">Remark </label>
        <textarea id="stageRemark" class="form-control" rows="3" placeholder="Enter remark..."></textarea>
      </div>
      `,
      showCancelButton: true,
      confirmButtonText: isLastStage ? 'Complete' : 'Assign',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#198754',
      didOpen: () => {
        setTimeout(() => { document.getElementById('stageRemark').focus(); }, 100);
      },
      preConfirm: () => {
        const remark = document.getElementById('stageRemark').value.trim();
        const userId = !isLastStage ? document.getElementById('nextStageUser').value : null;
        const storePersonId = (isProductionStage && !row.store_person_id)
          ? document.getElementById('storePersonSelect').value
          : null;

        if (!isLastStage && !userId) {
          this.$swal.showValidationMessage(`Please select a ${config.label} user`);
          return false;
        }
        if (isProductionStage && !row.store_person_id && !storePersonId) {
          this.$swal.showValidationMessage('Please select a store person');
          return false;        
        }
        return { 
          stage: config.stage, 
          assigned_to: !isLastStage ? userId : row.created_by?.id, 
          remark, 
          id: row.id,
          store_person_id: storePersonId  // <-- extra field
        };
      }
    });

    if (formValues) {
      // Store person assign karo pehle (agar hai)
      if (formValues.store_person_id) {
        await this.saveAssignStorePerson({ 
          store_person_id: formValues.store_person_id, 
          id: formValues.id 
        });
      }
      await this.saveCompleteStage(formValues);
    }
  } catch(error) {
    this.$swalToast(error.message, 'error');
    this.setLoading(false);
  }
},

async saveCompleteStage(formValues) {
  this.setLoading(true);
  try {
    const payload = { stage: formValues.stage, remark: formValues.remark };
    if (formValues.assigned_to) payload.assigned_to = formValues.assigned_to;
    // if (formValues.vehicle_number) payload.vehicle_number = formValues.vehicle_number;
    await axios.post(`/${this.module_url}/${formValues.id}/complete-stage`, payload);
    this.$swalToast('Stage completed successfully!', 'success');
    await this.loadAll();
  } catch(error) {
    this.$swalToast(error.response?.data?.message || 'Failed to complete stage', 'error');
  } finally {
    this.setLoading(false);
  }
},


    async assignToProduction(row) {
  // Production users
  try {
    this.setLoading(true);
    const response = await axios.get('/users/production');
    const productionUsers = response.data.data;
    this.setLoading(false);

    const { value: formValues } = await this.$swal.fire({
      title: 'Assign to Production',
      html: `
        <div class="mb-3">
          <label class="form-label fw-semibold">Select Production User <span class="text-danger">*</span></label>
          <select id="productionUser" class="form-select">
            <option value="">Choose Production User</option>
            ${productionUsers.map(u => `<option value="${u.id}">${u.name}</option>`).join('')}
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label fw-semibold">Remark </label>
          <textarea id="productionRemark" class="form-control" rows="3" placeholder="Enter remark..."></textarea>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Assign',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#198754',
      didOpen: () => {
        setTimeout(() => {
          document.getElementById('productionRemark').focus();
        }, 100);
      },
      preConfirm: () => {
        const userId = document.getElementById('productionUser').value;
        const remark = document.getElementById('productionRemark').value.trim();
        if (!userId) {
          this.$swal.showValidationMessage('Please select a production user');
          return false;
        }
        return { assigned_to: userId, remark, id: row.id };
      }
    });

    if (formValues) {
      await this.saveAssignProduction(formValues);
    }
  } catch(error) {
    this.$swalToast(error.message, 'error');
    this.setLoading(false);
  }
},

async saveAssignProduction(formValues) {
  this.setLoading(true);
  try {
    await axios.post(`/${this.module_url}/${formValues.id}/assign-production`, {
      assigned_to: formValues.assigned_to,
      remark: formValues.remark
    });
    this.$swalToast('Assigned to production successfully!', 'success');
    await this.loadAll();
  } catch(error) {
    this.$swalToast(error.response?.data?.message || 'Failed to assign', 'error');
  } finally {
    this.setLoading(false);
  }
},

async financeAction(row) {
  const { value: formValues } = await this.$swal.fire({
    title: 'Finance Action',
    html: `
      <div class="mb-3">
        <label class="form-label fw-semibold">Action <span class="text-danger">*</span></label>
        <select id="financeActionSelect" class="form-select">
          <option value="">Select Action</option>
          <option value="approved">Approve</option>
          <option value="rejected">Reject</option>
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label fw-semibold">Advance Amount</label>
        <div class="input-group">
          <span class="input-group-text">₹</span>
          <input type="text" id="financeAdvanceAmount" class="form-control" 
            value="${row.advance_amount || 0}" readonly 
            style="background:#f8f9fa;color:#6c757d;cursor:not-allowed;border-color:#dee2e6;" />
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label fw-semibold">Document</label>
        <input type="file" id="financeDocument" class="form-control" />
      </div>
      <div class="mb-3">
        <label class="form-label fw-semibold">Remark </label>
        <textarea id="financeRemark" class="form-control" rows="3" 
          placeholder="Enter remark..."></textarea>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Submit',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#198754',
    didOpen: () => {
      setTimeout(() => {
        document.getElementById('financeActionSelect').focus();
      }, 100);
    },
    preConfirm: () => {
      const action = document.getElementById('financeActionSelect').value;
      const remark = document.getElementById('financeRemark').value.trim();
      const file = document.getElementById('financeDocument').files[0] || null;

      if (!action) {
        this.$swal.showValidationMessage('Please select an action');
        return false;
      }
      if (file && file.size > 1024 * 1024) {
        this.$swal.showValidationMessage('Document size must not be greater than 1 MB');
        return false;
      }
      return {
        finance_action: action,
        advance_amount: row.advance_amount,
        remark_by_finance: remark,
        document: file,
        id: row.id
      };
    }
  });

  if (formValues) {
    await this.saveFinanceAction(formValues);
  }
},

async saveFinanceAction(formValues) {
  this.setLoading(true);
  try {
    const formData = new FormData();
    formData.append('_method', 'PATCH');
    formData.append('finance_action', formValues.finance_action);
    formData.append('advance_amount', formValues.advance_amount ?? '');
    formData.append('remark_by_finance', formValues.remark_by_finance);
    if (formValues.document) {
      formData.append('document', formValues.document);
    }

    await axios.post(`/${this.module_url}/${formValues.id}/finance-action`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    this.$swalToast('Finance action submitted successfully!', 'success');
    await this.loadAll();
  } catch (error) {
    if (error.response?.data?.errors) {
      const firstError = Object.values(error.response.data.errors)[0][0];
      this.$swalToast(firstError, 'error');
    } else {
      this.$swalToast(error.response?.data?.message || 'Failed to submit finance action', 'error');
    }
  } finally {
    this.setLoading(false);
  }
},
async saveDrawingUpload(formValues) {
  this.setLoading(true);
  try {
    const formData = new FormData();
    formValues.drawing_documents.forEach((doc, index) => {
      formData.append(`documents[${index}][document]`, doc.file);
      formData.append(`documents[${index}][name]`, doc.name);
      formData.append(`documents[${index}][document_type]`, 'drawing_document');
    });

    await axios.post(`/${this.module_url}/${formValues.id}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    // Auto email trigger after drawing upload
    // try {
    //   const soResponse = await axios.get(`/${this.module_url}/${formValues.id}/edit`);
    //   const so = soResponse.data.data;
    //   if (so.email) {
    //     await axios.post(`/${this.module_url}/${so.id}/email`, {
    //       to_email: so.email,
    //       mail_subject: `Sales Order #${so.so_number} - Drawing Ready for Review`,
    //       mail_body: `Dear ${so.name},<br><br>Your sales order drawing has been uploaded. Please review and approve or reject it.<br><br><a href="${window.location.origin}/finance-accounts/sales-orders/view/${so.public_token}" style="display:inline-block;padding:10px 20px;background:#2563eb;color:#fff;text-decoration:none;border-radius:6px;font-weight:600;">Review Sales Order</a>`,
    //       mail_footer: 'Thank you.'
    //     });
    //   }
    // } catch (emailError) {
    //   console.log('Email send failed:', emailError.message);
    // }

    this.$swalToast('Drawing documents uploaded successfully!', 'success');
    await this.loadAll();
  } catch (error) {
    if (error.response?.data?.errors) {
      const firstError = Object.values(error.response.data.errors)[0][0];
      this.$swalToast(firstError, 'error');
    } else {
      this.$swalToast(error.response?.data?.message || 'Failed to upload drawings', 'error');
    }
  } finally {
    this.setLoading(false);
  }
},


async saveCadDocument(formValues) {
  this.setLoading(true);
  try {
    const formData = new FormData();
    formData.append('documents[0][document]', formValues.pdf_document);
    formData.append('documents[0][document_type]', 'pdf_document');
    formData.append('documents[1][document]', formValues.cad_document);
    formData.append('documents[1][document_type]', 'cad_document');

    await axios.post(`/${this.module_url}/${formValues.id}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    this.$swalToast('CAD documents uploaded successfully!', 'success');
    await this.loadAll();
    return true;
    } catch (error) {
    if (error.response?.data?.errors) {
      const firstError = Object.values(error.response.data.errors)[0][0];
      this.$swalToast(firstError, 'error');
    } else {
      this.$swalToast(error.response?.data?.message || 'Failed to upload documents', 'error');
    }
    return false;
  } finally {
    this.setLoading(false);
  }
},

async uploadCadDocument(row) {
  try {
    this.setLoading(true);
    const response = await axios.get(`/${this.module_url}/${row.id}/add-on-detail`);
    const data = response.data.data;

    const hasPdf = data.documents?.some(d => d.document_type === 'pdf_document');
    const hasCad = data.documents?.some(d => d.document_type === 'cad_document');

    if (hasPdf && hasCad) {
      this.$swalToast('CAD documents already uploaded for this order', 'warning');
      return;
    }
  } catch (error) {
    this.$swalToast(error.message, 'error');
    return;
  } finally {
    this.setLoading(false);
  }

  const { value: formValues } = await this.$swal.fire({
    title: 'Upload CAD Document',
    html: `
      <div class="mb-3">
        <label class="form-label fw-semibold">PDF Document <span class="text-danger">*</span></label>
        <input type="file" id="pdfDocument" class="form-control" accept=".pdf" />
      </div>
      <div class="mb-3">
        <label class="form-label fw-semibold">CAD Document <span class="text-danger">*</span></label>
        <input type="file" id="cadDocument" class="form-control" />
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Upload',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#198754',
    preConfirm: () => {
      const pdfFile = document.getElementById('pdfDocument').files[0] || null;
      const cadFile = document.getElementById('cadDocument').files[0] || null;

      if (!pdfFile) {
        this.$swal.showValidationMessage('Please select a PDF document');
        return false;
      }
      if (!cadFile) {
        this.$swal.showValidationMessage('Please select a CAD document');
        return false;
      }
      return {
        pdf_document: pdfFile,
        cad_document: cadFile,
        id: row.id
      }
    }
  });

  if (formValues) {
    const success = await this.saveCadDocument(formValues);
    if (success) {
      this.$refs.storeDispatchItemModal.open(row);
    }
  }
},

    async saveApproveByClient(formValues) {
  this.setLoading(true);
  try {
    await axios.patch(`/${this.module_url}/${formValues.id}/approve-by-client`, {
      remark_approved_by_client: formValues.remark_approved_by_client
    });
    this.$swalToast('Approved by client successfully!', 'success');
    await this.loadAll();
  } catch (error) {
    this.$swalToast(error.response?.data?.message || 'Failed to approve', 'error');
  } finally {
    this.setLoading(false);
  }
},

    async approveByClient(row) {
  const { value: formValues } = await this.$swal.fire({
    title: 'Approved by Client',
    html: `
      <div class="mb-3">
        <label class="form-label fw-semibold">Remark <span class="text-danger">*</span></label>
        <textarea id="approveByClientRemark" class="form-control" rows="3" placeholder="Enter remark..."></textarea>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Sumbit',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#198754',
    didOpen: () => {
      setTimeout(() => {
        document.getElementById('approveByClientRemark').focus();
      }, 100);
    },
    preConfirm: () => {
      const remark = document.getElementById('approveByClientRemark').value.trim();
      if (!remark) {
        this.$swal.showValidationMessage('Please enter a remark');
        return false;
      }
      if (remark.length < 10) {
        this.$swal.showValidationMessage('Remark must be at least 10 characters long');
        return false;
      }
      return {
        remark_approved_by_client: remark,
        id: row.id
      }
    }
  });

  if (formValues) {
    await this.saveApproveByClient(formValues);
  }
},


  async viewAddOnDetail(row) {
  try {
    this.setLoading(true);
    const response = await axios.get(`/${this.module_url}/${row.id}/add-on-detail`);
    const detail = response.data.data;
    this.selectedOrderDetail = detail;

    const modalEl = document.getElementById('order_detail_modal');
    let modal = Modal.getInstance(modalEl);
    if (!modal) { modal = new Modal(modalEl); }
    modal.show();
  } catch(error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.setLoading(false);
  }
},

async openUploadDrawing(row) {
  try {
    this.setLoading(true);
    const response = await axios.get(`/${this.module_url}/${row.id}/add-on-detail`);
    const data = response.data.data;

    const hasDrawing = data.documents?.some(d => d.document_type === 'drawing_document');
    if (hasDrawing) {
      this.$swalToast('Drawing documents already uploaded for this order', 'warning');
      return;
    }
  } catch (error) {
    this.$swalToast(error.message, 'error');
    return;
  } finally {
    this.setLoading(false);
  }

  const { value: formValues } = await this.$swal.fire({
    title: 'Upload Drawing Documents',
    html: `
      <div id="drawingFilesContainer">
        <div class="mb-3 drawing-file-row" style="border:1px solid #e9ecef;border-radius:8px;padding:12px;">
          <div class="mb-2">
            <label class="form-label fw-semibold mb-1">Document Name</label>
            <input type="text" class="form-control drawing-name-input" placeholder="Enter document name" />
          </div>
          <div>
            <label class="form-label fw-semibold mb-1">Document File <span class="text-danger">*</span></label>
            <input type="file" class="form-control drawing-file-input" accept="image/*,.pdf,.dxf" />
          </div>
        </div>
      </div>
      <button type="button" id="addMoreDrawingBtn" class="btn btn-sm btn-outline-success d-flex align-items-center gap-1 mt-2">
        <i class="ti ti-plus"></i> Add More
      </button>
    `,
    showCancelButton: true,
    confirmButtonText: 'Upload',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#198754',
    didOpen: () => {
      document.getElementById('addMoreDrawingBtn').addEventListener('click', () => {
        const container = document.getElementById('drawingFilesContainer');
        const count = container.querySelectorAll('.drawing-file-row').length + 1;
        const newRow = document.createElement('div');
        newRow.className = 'mb-3 drawing-file-row';
        newRow.style = 'border:1px solid #e9ecef;border-radius:8px;padding:12px;position:relative;';
        newRow.innerHTML = `
          <button type="button" class="btn btn-sm btn-outline-danger remove-drawing-btn" style="position:absolute;top:8px;right:8px;padding:2px 8px;font-size:12px;">
            <i class="ti ti-x"></i>
          </button>
          <div class="mb-2">
            <label class="form-label fw-semibold mb-1">Document Name ${count}</label>
            <input type="text" class="form-control drawing-name-input" placeholder="Enter document name" />
          </div>
          <div>
            <label class="form-label fw-semibold mb-1">Document File ${count} <span class="text-danger">*</span></label>
            <input type="file" class="form-control drawing-file-input" accept="image/*,.pdf,.dxf" />
          </div>
        `;
        container.appendChild(newRow);
        newRow.querySelector('.remove-drawing-btn').addEventListener('click', () => {
          newRow.remove();
        });
      });
    },
    preConfirm: () => {
      const rows = document.querySelectorAll('.drawing-file-row');
      const documents = [];
      rows.forEach(row => {
        const file = row.querySelector('.drawing-file-input').files[0] || null;
        const name = row.querySelector('.drawing-name-input').value.trim() || '';
        if (file) {
          documents.push({ file, name });
        }
      });

      if (documents.length === 0) {
        this.$swal.showValidationMessage('Please select at least one drawing document');
        return false;
      }
      return {
        drawing_documents: documents,
        id: row.id
      }
    }
  });

  if (formValues) {
    await this.saveDrawingUpload(formValues);
  }
},

    async getDrawingUsers(){
  try{
    const response = await axios.get('/users/drawing');
    this.drawingUsers = response.data.data;
  }catch(error){
    this.$swalToast(error.message, 'error');
  }
},

    async generateTaxInvoice(row) {
  try {
    this.setLoading(true);
    const response = await axios.get(`/${this.module_url}/${row.public_token}`);
    const salesOrder = response.data.data;

    // Invoice modal ko pre-fill karo
    await this.$refs.invoiceModal.createFromSalesOrder(salesOrder);

    // Invoice modal open karo
    const modalEl = document.getElementById("invoice_modal");
    let modal = Modal.getInstance(modalEl);
    if (!modal) { modal = new Modal(modalEl); }
    modal.show();
  } catch(error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.setLoading(false);
  }
},

    async loadAll(){
      this.expandedRows = [];
     this.rowRevisions = {};
     this.salesOrders();
     this.statusData(); 
    },

    async selectStatus(status){
     this.filter.status = status;
     await this.salesOrders();
    },

    async statusData(){
     try{
      const response = await axios.get(`/sales-orders/status-wise/data`);
      this.status_data = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }
    },

    async getUsers(){
     try{
      const response = await productionUsers();
      this.users = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }
    },

    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

async approve(id){
  const { value: formValues } = await this.$swal.fire({
    title: 'Approve Sales Order',
    html: `
      <div class="mb-3">
        <label class="form-label fw-semibold">Approval Remark</label>
        <textarea id="approveRemark" class="form-control" rows="3" placeholder="Enter approval remark..."></textarea>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Approve',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#198754',
    didOpen: () => {
    setTimeout(() => {
      document.getElementById('approveRemark').focus();
    }, 100);
  },
  preConfirm: () => {
    const remark = document.getElementById('approveRemark').value.trim();
    return {
      remark: remark,
      id: id
    }
  }
  });

  if(formValues){
    await this.saveApprove(formValues);
  }
},

async assignToDrawing(row) {
  if(!this.drawingUsers.length){
    await this.getDrawingUsers();
  }
  const { value: formValues } = await this.$swal.fire({
    title: 'Assign to Drawing User',
    html: `
      <div class="mb-3">
        <label class="form-label fw-semibold">Select Drawing User <span class="text-danger">*</span></label>
        <select id="drawingUser" class="form-select">
          <option value="">Choose Drawing User</option>
          ${this.drawingUsers.map(user => 
            `<option value="${user.id}">${user.name}</option>`
          ).join('')}
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label fw-semibold">Remark </label>
        <textarea id="drawingRemark" class="form-control" rows="3" placeholder="Enter remark..."></textarea>
      </div>
      <div class="mb-3">
        <label class="form-label fw-semibold">Upload Document</label>
        <input type="file" id="drawingDocument" class="form-control" />
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Assign',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#198754',
    didOpen: () => {
      setTimeout(() => {
        document.getElementById('drawingRemark').focus();
      }, 100);
    },
    preConfirm: () => {
      const drawingUserId = document.getElementById('drawingUser').value;
      const remark = document.getElementById('drawingRemark').value.trim();
      const fileInput = document.getElementById('drawingDocument');
      const file = fileInput.files[0] || null;

      if(!drawingUserId){
        this.$swal.showValidationMessage('Please select a drawing user');
        return false;
      }
      return {
        drawing_by: drawingUserId,
        remark_assign_drawing: remark,
        document: file,
        id: row.id
      }
    }
  });

  if(formValues){
    await this.saveAssignDrawing(formValues);
  }
},

async saveAssignDrawing(formValues) {
  this.setLoading(true);
  try{
    const formData = new FormData();
    formData.append('_method', 'PATCH');
    formData.append('drawing_by', formValues.drawing_by);
    formData.append('remark_assign_drawing', formValues.remark_assign_drawing);
    if(formValues.document){
      formData.append('document', formValues.document);
    }

    await axios.post(`/${this.module_url}/${formValues.id}/assign-drawing`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    this.$swalToast('Assigned to drawing user successfully!', 'success');
    await this.loadAll();
  }catch(error){
    this.$swalToast(error.response?.data?.message || 'Failed to assign', 'error');
  }finally{
    this.setLoading(false);
  }
},


   async saveApprove(formValues) {
  this.setLoading(true);
  try{
    const response = await axios.patch(`/${this.module_url}/${formValues.id}/approve`, {
      remark: formValues.remark
    });
   
    this.$swalToast('Sales Order approved and assigned to drawing!', 'success');
    await this.loadAll();
  }catch(error){
    this.$swalToast(error.response?.data?.message || 'Failed to approve', 'error');
  }finally{
    this.setLoading(false);
  }
},

async reject(id) {
  const { value: formValues } = await this.$swal.fire({
    title: 'Reject Sales Order',
    html: `
      <div class="mb-3">
        <label class="form-label fw-semibold">Rejection Remark <span class="text-danger">*</span></label>
        <textarea id="rejectRemark" class="form-control" rows="3" placeholder="Enter reason for rejection..." required></textarea>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Reject Sales Order',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#dc3545',
    didOpen: () => {
      setTimeout(() => {
        document.getElementById('rejectRemark').focus();
      }, 100);
    },
    preConfirm: () => {
      const remark = document.getElementById('rejectRemark').value.trim();
      if(!remark){
        this.$swal.showValidationMessage('Please enter a rejection remark');
        return false;
      }
      if(remark.length < 10){
        this.$swal.showValidationMessage('Remark must be at least 10 characters long');
        return false;
      }
      return {
        remark: remark,
        id: id
      }
    }
  });
  if(formValues){
    await this.saveReject(formValues);
  }
},

   async saveReject(formValues) {
    this.setLoading(true);
     try{
      const response = await axios.patch(`/${this.module_url}/${formValues.id}/reject`, {
       remark: formValues.remark
      });
    
      this.$swalToast('Sales Order rejected successfully!', 'success');
      // Refresh current page data
      await this.loadAll();
     }catch(error){
      this.$swalToast(error.response?.data?.message || 'Failed to reject sales order', 'error');
     }finally{
      this.setLoading(false);
     }
   },
  
   async updateStatus(row) {
    const statuses = [
     { value: 'dispatched', label: 'Dispatched' },
     { value: 'completed', label: 'Completed' },
    ];

    const { value: formValues } = await this.$swal.fire({
     title: 'Update Status',
     html: `
      <div class="mb-3">
       <label class="form-label fw-semibold">Status</label>
       <select id="statusSelect" class="form-select">
        ${statuses.map(status => 
         `<option value="${status.value}" ${row.status === status.value ? 'selected' : ''}>
          ${status.label}
         </option>`
        ).join('')}
       </select>
      </div>
      <div class="mb-3">
       <label class="form-label fw-semibold">Tracking/LR Number</label>
       <input id="trackingNo" class="form-control" placeholder="Enter Tracking/LR number" value="${row.tracking_number || ''}" />
      </div>
      `,
     showCancelButton: true,
     confirmButtonText: 'Update',
     cancelButtonText: 'Cancel',
     preConfirm: () => {
      const trackingNo = document.getElementById('trackingNo').value.trim();
      if(!trackingNo){
       this.$swal.showValidationMessage('Please enter tracking/LR number');
       return false;
      }
  
      return {
       status: document.getElementById('statusSelect').value,
       tracking_number: trackingNo,
       id: row.id
      }
     }
    });

   if(formValues){
    await this.saveStatusUpdate(formValues, row);
   }
  },

  async saveStatusUpdate(formValues, row) {
   this.setLoading(true);
    try{
     // Status update
     await axios.patch(`/${this.module_url}/${formValues.id}/status/${formValues.status}`);
    
     if(formValues.tracking_number){
      await axios.patch(`/${this.module_url}/${formValues.id}/tracking`, {
        tracking_number: formValues.tracking_number
      });
     }

     this.$swalToast('Status updated successfully!', 'success');
     await this.loadAll();
    }catch(error){
     this.$swalToast(error.response?.data?.message || 'Failed to update status', 'error');
    }finally{
     this.setLoading(false);
    }
   },

   async updateTracking(row) {
    const { value: formValues } = await this.$swal.fire({
     title: 'Update Tracking',
     html: `
      <div class="mb-3">
        <label class="form-label fw-semibold">Tracking/LR Number</label>
        <input id="trackingNo" class="form-control" placeholder="Enter Tracking/LR number" value="${row.tracking_number || ''}" />
      </div>
     `,
     showCancelButton: true,
     confirmButtonText: 'Update Tracking',
     cancelButtonText: 'Cancel',
     preConfirm: () => {
      const trackingNo = document.getElementById('trackingNo').value.trim();
            
      if(!trackingNo){
       this.$swal.showValidationMessage('Please enter tracking number');
       return false;
      }
      
      return {
       tracking_number: trackingNo,
       id: row.id
      };
     }
    });

    if(formValues){
     await this.saveTrackingUpdate(formValues, row);
    }
   },

   async saveTrackingUpdate(formValues, row) {
    this.setLoading(true);
     try{
      const response = await axios.patch(`/${this.module_url}/${formValues.id}/tracking`, {
       tracking_number: formValues.tracking_number 
      });
      this.$swalToast('Tracking updated successfully!', 'success');
      // Refresh current page data
      await this.loadAll();
     }catch(error){
      if(error.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.response?.data?.message || 'Failed to update tracking', 'error'); 
      }
     }finally{
      this.setLoading(false);
     }
   },

    async salesOrders(page = 1) {
     this.setLoading(true);
     try{
      const params = {
 page,
 status: this.filter.status,
 to_date: this.filter.to_date,
 from_date: this.filter.from_date,
 per_page: this.pagination.per_page,
 search_keyword: this.filter.search_keyword.trim() || ''
};
if (this.filter.user_id) params.user_id = this.filter.user_id;
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/${this.module_url}?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

   async salesOrderPDF(id){
    try{
     const response = await viewPDF(id);
     const file = new Blob([response.data], { type: 'application/pdf' });
     const fileURL = URL.createObjectURL(file);
     window.open(fileURL, '_blank');
    }catch(error){
     this.$swalToast("Failed to open PDF", 'error');
     console.error(error);
    }
   }, 

  //  changePage(url){
  //   if (!url) return;
  //   const page = new URL(url).searchParams.get("page");
  //   this.salesOrders(page);
  //  },

   clearFilter(){
 this.filter.status = '';
 this.filter.to_date = '';
 this.filter.from_date = '';
 this.filter.search_keyword = '';
 this.filter.user_id = '';
 this.salesOrders();
},

   async approveAfterSave(id) {
    await this.approve(id);
   },

   async rejectAfterSave(id) {
    await this.reject(id);
   },

   async openUpdateStatusFromQC(id) {
    // Find the row by id from current data to pass to updateStatus
    const row = this.data.find(r => r.id === id);
    if(row){
     await this.updateStatus(row);
    }
   },
    
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <!-- <div class="me-2 mb-2" v-if="pagination.total">
        <div class="dropdown">
        <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown"><i class="ti ti-file-export me-1"></i>Export
        </a>
        <ul class="dropdown-menu dropdown-menu-end p-3">
        <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
        </li>
        </ul>
        </div>
        </div> -->
        

        <div class="mb-2" v-if="auth?.role?.is_sales_order_approver">
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.salesOrderModal.salesOrder();">
            <i class="ti ti-circle-plus me-2"></i>Add Sales Order
          </a>
        </div>
       
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="row">

   <div class="col-md-3 cursor-pointer" v-for="(row, index) in status_data" :key="index" @click="selectStatus(row.status);">
    <div class="card flex-fill">
    <div class="card-body">
    <div class="d-flex align-items-center overflow-hidden mb-2">
    <div>
      <p class="fs-12 fw-normal mb-1 text-truncate">{{row.status}}</p>
      <!--<h5>{{app_currency.code}} {{row.amount}}</h5>-->
      <h5>Total: {{row.count}}</h5>
    </div>
    </div>
    <div class="attendance-report-bar mb-2">
    <div class="progress" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="height: 5px;">
      <div :class="`progress-bar ${row.bg_color}`" :style="`width: ${row.percentage}%;`"></div>
    </div>
    </div>
    <div>
    <!-- <p class="fs-12 fw-normal d-flex align-items-center text-truncate"><span class="text-muted fs-12 d-flex align-items-center me-1">Total: {{row.count}}</span></p> -->
    </div>
    </div>
    </div>
   </div> 

  </div>


    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-center flex-wrap row-gap-3">
    <!-- <h5>Payments List</h5> -->
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-1" v-if="filter.search_keyword || filter.from_date || filter.to_date || filter.status || filter.user_id">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>

    <div class="me-3">
      <vue-select
        v-model="filter.status"
        :options="[
          { label: 'Draft', value: 'draft' },
          { label: 'Approved', value: 'approved' },
          { label: 'Processing', value: 'processing' },
          { label: 'Dispatched', value: 'dispatched' },
          { label: 'Completed', value: 'completed' },
          { label: 'Cancelled', value: 'cancelled' },
          { label: 'Rejected', value: 'rejected' },
        ]"
        label="label"
        :reduce="s => s.value"
        placeholder="Status"
        :clearable="true"
        @update:modelValue="salesOrders()"
        style="min-width: 180px;"
      ></vue-select>
    </div>

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="filter.search_keyword" placeholder="Search...."/>
    </div>
    </div>

    <div class="">
     <button type="button" class="btn btn-dark" @click="salesOrders()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

<div class="card-body card-table-wrapper">
  <app-table
    :columns="visibleColumns"
    :rows="data"
    :pagination="pagination"
    :loading="false"
    empty-text="No records found."
    empty-icon="ti ti-file-off"
    @page-change="salesOrders"
  >

    <!-- SO Number -->
    <template #so_number="{ row }">
      <div style="display:flex;align-items:center;gap:6px;">
        <button type="button"
          @click="toggleRevisions(row)"
          style="width:20px;height:20px;border:1px solid #cbd5e1;background:#fff;border-radius:5px;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;padding:0;"
          :title="isExpanded(row.id) ? 'Hide revisions' : 'Show revisions'">
          <i :class="isExpanded(row.id) ? 'ti ti-chevron-down' : 'ti ti-chevron-right'" style="font-size:13px;color:#475569;"></i>
        </button>
        <span class="fw-bold">{{ row.so_number }}</span>
      </div>
    </template>

    <!-- Status -->
    <template #status="{ row }">
      <StatusBadge :status="row.status"></StatusBadge>
    </template>

    <!-- Type  -->
    <template #type="{ row }">
      <span class="badge" 
        :class="row.type === 'trading' ? 'bg-info-subtle text-info' : 'bg-primary-subtle text-primary'"
        style="font-size:10px;padding:4px 10px;text-transform:capitalize;">
        {{ row.type }}
      </span>
    </template>

    <!-- Client Name -->
    <template #client_name="{ row }">
      <span v-if="shouldMaskClientInfo">****</span>
      <span v-else>{{ row?.party?.name }}</span>
    </template>

    <!-- Client Phone -->
    <template #client_phone="{ row }">
      <phone-mask 
        v-if="shouldMaskClientInfo" 
        :phone="row?.party?.mobile"
        :visibleDigits="0">
      </phone-mask>
      <span v-else>{{ row?.party?.mobile }}</span>
    </template>

    <!-- Created By -->
    <template #created_by="{ row }">
      <img v-if="row?.created_by?.image" :src="row?.created_by?.image_url" width="22" class="rounded-circle" />
      <i v-else class="ti ti-user-circle fs-18 text-muted"></i>
      {{ row?.created_by?.name }}
    </template>


    <!-- Drawing Remark -->
    <template #drawing_remark="{ row }">
      <span v-if="row.remark_assign_drawing" 
        :title="row.remark_assign_drawing"
        style="font-size:11px;color:#166534;background:#f0fdf4;padding:3px 8px;border-radius:6px;border:1px solid #bbf7d0;display:inline-block;max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;">
        {{ row.remark_assign_drawing }}
      </span>
      <span v-else class="text-muted">—</span>
    </template>

      <!-- approver Remark -->
      <template #approver_remark="{ row }">
        <span v-if="row.remark"
          :title="row.remark"
          style="font-size:11px;color:#166534;background:#f0fdf4;padding:3px 8px;border-radius:6px;border:1px solid #bbf7d0;display:inline-block;max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;">
          {{ row.remark }}
        </span>
        <span v-else class="text-muted">—</span>
      </template>

      <template #production_status="{ row }">
    <div v-if="row.production_stage">
      <span class="badge" 
        :class="{
          'bg-primary-subtle text-primary': !['dispatched','completed'].includes(row.production_stage),
          'bg-success-subtle text-success': row.production_stage === 'dispatched' || row.production_stage === 'completed'
        }"
        style="font-size:10px;padding:4px 10px;text-transform:capitalize;">
        {{ row.production_stage.replace('_', ' ') }}
      </span>
      <div v-if="row.remark_dispatch" 
        :title="row.remark_dispatch"
        style="font-size:10px;color:#6b7280;margin-top:3px;max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
        {{ row.remark_dispatch }}
      </div>
      <div v-if="row.vehicle_number" 
        style="font-size:10px;color:#1e40af;margin-top:2px;">
        🚛 {{ row.vehicle_number }}
      </div>
    </div>
    <span v-else class="text-muted">—</span>
  </template>

    <!-- Client Action -->
    <template #client_action="{ row }">
      <div v-if="row.client_action === 'approved'">
        <span class="badge bg-success-subtle text-success" style="font-size:10px;padding:4px 10px;">Approved</span>
        <div v-if="row.remark_by_client" style="font-size:10px;color:#6b7280;margin-top:3px;max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" :title="row.remark_by_client">
          {{ row.remark_by_client }}
        </div>
      </div>
      <div v-else-if="row.client_action === 'rejected'">
        <span class="badge bg-danger-subtle text-danger" style="font-size:10px;padding:4px 10px;">Rejected</span>
        <div v-if="row.remark_by_client" style="font-size:10px;color:#6b7280;margin-top:3px;max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" :title="row.remark_by_client">
          {{ row.remark_by_client }}
        </div>
      </div>
      <span v-else class="text-muted">—</span>
    </template>

    <!-- Date -->
    <template #date="{ row }">
      {{ $formatDate(row.created_at, 'DD-MM-YYYY') }}
    </template>

    <!-- Finance Action -->
    <template #finance_action="{ row }">
      <div v-if="row.finance_action === 'approved'">
        <span class="badge bg-success-subtle text-success" style="font-size:10px;padding:4px 10px;">
          <i class="ti ti-check me-1"></i>Approved
        </span>
        <div v-if="row.remark_by_finance" 
          style="font-size:10px;color:#6b7280;margin-top:3px;max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" 
          :title="row.remark_by_finance">
          {{ row.remark_by_finance }}
        </div>
        <div v-if="row.advance_amount && parseFloat(row.advance_amount) > 0"
          style="font-size:10px;color:#1e40af;margin-top:2px;">
          ₹{{ row.advance_amount }}
        </div>
      </div>
      <div v-else-if="row.finance_action === 'rejected'">
        <span class="badge bg-danger-subtle text-danger" style="font-size:10px;padding:4px 10px;">
          <i class="ti ti-x me-1"></i>Rejected
        </span>
        <div v-if="row.remark_by_finance" 
          style="font-size:10px;color:#6b7280;margin-top:3px;max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" 
          :title="row.remark_by_finance">
          {{ row.remark_by_finance }}
        </div>
      </div>
      <span v-else class="text-muted">—</span>
    </template>

    <!-- Advance Amount -->
    <template #advance_amount="{ row }">
      <span v-if="row.advance_amount && parseFloat(row.advance_amount) > 0" 
        style="font-size:11px;color:#1e40af;background:#eff6ff;padding:3px 8px;border-radius:6px;border:1px solid #bfdbfe;">
        ₹ {{ row.advance_amount }}
      </span>
      <span v-else class="text-muted">—</span>
    </template>

    <!-- Actions -->
    <template #actions="{ row }">
      <div class="dropdown" v-if="row.status !== 'superseded'">
        <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="ti ti-dots-vertical"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end p-3">
          <li v-if="auth?.role?.is_sales_order_approver && row.status !== 'dispatched' && row.status !== 'completed'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_modal" @click="$refs.salesOrderModal.salesOrder(row?.public_token)"><i class="ti ti-edit me-1"></i>Edit</a>
          </li>
          <li v-if="(auth?.type === 'ADMIN' || row.created_by?.id === auth?.id) && !['superseded','completed','cancelled','dispatched','rejected'].includes(row.status)">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_modal" @click="$refs.salesOrderModal.reviseSalesOrder(row?.public_token)"><i class="ti ti-refresh me-1"></i>Revise Sales Order</a>
          </li>
          <li v-if="(auth?.type === 'ADMIN' || row.created_by?.id === auth?.id) && row.type === 'manufacturing' && !row.drawing_by">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="assignToDrawing(row)">
              <i class="ti ti-user-check me-1"></i>Assign to Drawing User
            </a>
          </li>
          <!-- Send Drawing Review Mail -->
           <li v-if="
              row.type === 'manufacturing' &&
              row.drawing_documents?.length &&
              !row.client_action &&
              (auth?.type === 'ADMIN' || row.created_by?.id === auth?.id)
            ">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" 
              @click="sendDrawingReviewMail(row)">
              <i class="ti ti-mail me-1"></i>Send Drawing Review Mail
            </a>
          </li>

            <!-- Assign to Approver -->
            <li v-if="
              row.type === 'manufacturing' &&
              row.client_action === 'approved' &&
              !row.approved_by &&
              (auth?.type === 'ADMIN' || row.created_by?.id === auth?.id)
            ">
              <a class="dropdown-item rounded-1" href="javascript:void(0);" 
                @click="assignToApprover(row)">
                <i class="ti ti-user-check me-1"></i>Assign to Approver
              </a>
            </li>

          <!-- Assign to Production -->
         <li v-if="auth?.role?.is_sales_order_approver && row.status === 'approved' && !row.production_assigned_to && !row.production_stage">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="assignToProduction(row)">
              <i class="ti ti-user-plus me-1"></i>Assign to Production
            </a>
          </li>
          <!-- Complete Stage -->
          <li v-if="
            (auth?.role?.is_sales_order_production && row.production_stage === 'production' && row.production_assigned_to == auth?.id) ||
            (auth?.role?.is_sales_order_cutting && row.production_stage === 'cutting' && row.production_assigned_to === auth?.id) ||
            (auth?.role?.is_sales_order_bending && row.production_stage === 'bending' && row.production_assigned_to === auth?.id) ||
            (auth?.role?.is_sales_order_fabrication && row.production_stage === 'fabrication' && row.production_assigned_to === auth?.id) ||
            (auth?.role?.is_sales_order_powder_coating && row.production_stage === 'powder_coating' && row.production_assigned_to === auth?.id) ||
            (auth?.role?.is_sales_order_packaging && row.production_stage === 'packaging' && row.production_assigned_to === auth?.id)
          ">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="completeStage(row)">
              <i class="ti ti-circle-check me-1"></i>Complete Stage
            </a>
          </li>
          <!-- Assign to Dispatch -->
          <li v-if="(auth?.type === 'ADMIN' || row.created_by?.id === auth?.id) && row.production_stage === 'sales' && row.finance_action === 'approved'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="assignToDispatch(row)">
              <i class="ti ti-truck me-1"></i>Assign to Dispatch
            </a>
          </li>
          <li v-if="(auth?.type === 'ADMIN' || row.created_by?.id === auth?.id) && row.type === 'trading' && !row.store_person_id">
              <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="assignStorePerson(row)">
                  <i class="ti ti-building-store me-1"></i>Assign to Store Person
              </a>
          </li>
          <li v-if="auth?.store_person?.id && auth?.store_person?.id === row.store_person_id && !row.delivery_challan">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="createDeliveryChallan(row)">
              <i class="ti ti-truck-delivery me-1"></i>Create Delivery Challan
            </a>
          </li>
          <li v-if="auth?.type === 'ADMIN' || auth?.role?.is_sales_order_approver || auth?.role?.is_sales_order_production || auth?.is_finance_user">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="salesOrderPDF(row.id)"><i class="ti ti-file-type-pdf me-1"></i>View PDF</a>
          </li>
        <!-- Finance Action -->
        <li v-if="auth?.is_finance_user && !row.finance_action && row.production_stage === 'sales'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" 
              @click="financeAction(row)">
              <i class="ti ti-cash me-1"></i>Finance Action
            </a>
          </li>
          <li v-if="auth?.type === 'ADMIN' && row.finance_action === 'rejected'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="approveFinanceAction(row)">
              <i class="ti ti-shield-check me-1"></i>Approve Finance Action
            </a>
          </li>
          <!-- <li v-if="auth?.role?.is_sales_order_production">
            <router-link class="dropdown-item rounded-1" :to="{ name: 'packaging-list', params: { public_token: row.public_token } }" target="_blank">
              <i class="ti ti-package me-1"></i>Print Packaging List
            </router-link>
          </li> -->
          <!-- <li v-if="auth?.role?.is_sales_order_production && !row.invoice_id">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="generateTaxInvoice(row)"><i class="ti ti-file-invoice me-1"></i>Generate Tax Invoice</a>
          </li> -->
          <!-- <li v-if="auth?.role?.is_sales_order_production">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_qc_status_modal" @click="$refs.salesOrderModal.qcStatus(row.id, row.so_number, true, row.delivery_image)"><i class="ti ti-truck me-1"></i>Update QC Status</a>
          </li> -->
          <!-- <li v-if="auth?.role?.is_sales_order_production">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="updateStatus(row)"><i class="ti ti-progress me-1"></i>Update Status</a>
          </li> -->
          <!-- <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_qc_status_modal" @click="$refs.salesOrderModal.qcStatus(row?.id, row?.so_number, false, row?.delivery_image)"><i class="ti ti-file-type-pdf me-1"></i>View QC Status</a>
          </li> -->
          <li v-if="auth?.type === 'ADMIN'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_delete_modal" @click="$refs.salesOrderModal.salesOrder(row.public_token)"><i class="ti ti-trash me-1"></i>Delete</a>
          </li>
          <li v-if="auth?.role?.is_sales_order_drawing && row.type === 'manufacturing' && row.drawing_by === auth?.id">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openUploadDrawing(row)"><i class="ti ti-upload me-1"></i>Upload Document</a>
          </li>
          <li v-if="auth?.role?.is_sales_order_drawing && row.client_action === 'approved'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="uploadCadDocument(row)">
              <i class="ti ti-file-upload me-1"></i>Upload CAD Document
            </a>
          </li>
          <li v-if="auth?.role?.is_sales_order_drawing && row.client_action === 'approved' && !row.store_dispatch_lists_count">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="$refs.storeDispatchItemModal.open(row)">
              <i class="ti ti-package me-1"></i>Add Store Dispatch Item
            </a>
          </li>
          <li v-if="
            auth?.role?.is_sales_order_drawing ||
            auth?.role?.is_sales_order_approver ||
            auth?.role?.is_sales_order_production ||
            auth?.role?.is_sales_order_cutting ||
            auth?.role?.is_sales_order_bending ||
            auth?.role?.is_sales_order_fabrication ||
            auth?.role?.is_sales_order_powder_coating ||
            auth?.role?.is_sales_order_packaging ||
            (auth?.store_person?.id && auth?.store_person?.id === row.store_person_id)
          ">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="viewAddOnDetail(row)">
              <i class="ti ti-eye me-1"></i>View Order Detail
            </a>
          </li>

          <!-- <li v-if="auth?.store_person?.id == row.store_person_id">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="viewAddOnDetail(row)">
              <i class="ti ti-eye me-1"></i>View Order Detail
            </a>
          </li> -->
          <!-- for Dispatch user  -->
          <li v-if="auth?.role?.is_sales_order_dispatch && row.production_stage === 'ready_for_dispatch' && row.finance_action === 'approved'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="dispatchOrder(row)">
              <i class="ti ti-truck-delivery me-1"></i>Dispatch Order
            </a>
          </li>
          <li v-if="row.created_by?.id === auth?.id && row.production_stage === 'sales' && !row.finance_action">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="notifyFinance(row)">
              <i class="ti ti-bell-ringing me-1"></i>Notify Finance Approver
            </a>
          </li>
         <li>
          <a class="dropdown-item rounded-1" href="javascript:void(0);" 
            data-bs-toggle="modal" data-bs-target="#sales_order_detail_modal"
            @click="$refs.salesOrderModal.salesOrderActivity(row);">
            <i class="ti ti-list-details me-1"></i>Sales Order Activity
          </a>
        </li>
        </ul>
      </div>
      <span v-else style="font-size:11px;color:#94a3b8;font-style:italic;">Revised</span>
    </template>

    <!-- Revisions expansion -->
<template #row-expansion="{ row }">
  <div v-if="isExpanded(row.id)"
    style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;margin:0 8px 8px;padding:12px 16px;">

    <!-- Loading -->
    <div v-if="loadingRevisions[row.id]" style="text-align:center;padding:20px;color:#94a3b8;font-size:12px;">
      <i class="ti ti-loader" style="font-size:18px;"></i> Loading revisions...
    </div>

    <!-- Revisions table -->
    <template v-else-if="rowRevisions[row.id] && rowRevisions[row.id].length">
      <div style="font-size:11px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:10px;display:flex;align-items:center;gap:6px;">
        <i class="ti ti-versions" style="font-size:14px;color:#2563eb;"></i>
        Revisions of {{ row.so_number }}
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead>
          <tr style="background:#1e293b;">
            <th style="padding:7px 10px;color:#fff;font-weight:600;font-size:10.5px;text-align:left;border-radius:6px 0 0 6px;">Rev</th>
            <th style="padding:7px 10px;color:#fff;font-weight:600;font-size:10.5px;text-align:left;">SO No</th>
            <th style="padding:7px 10px;color:#fff;font-weight:600;font-size:10.5px;text-align:right;">Total</th>
            <th style="padding:7px 10px;color:#fff;font-weight:600;font-size:10.5px;text-align:center;">Status</th>
            <th style="padding:7px 10px;color:#fff;font-weight:600;font-size:10.5px;text-align:left;">Created</th>
            <th style="padding:7px 10px;color:#fff;font-weight:600;font-size:10.5px;text-align:center;border-radius:0 6px 6px 0;">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="rev in rowRevisions[row.id]" :key="rev.id" style="border-bottom:1px solid #eef2f7;">
            <td style="padding:8px 10px;color:#64748b;font-weight:600;">R{{ rev.revision_number }}</td>
            <td style="padding:8px 10px;font-weight:600;color:#0f172a;">{{ rev.so_number }}</td>
            <td style="padding:8px 10px;text-align:right;font-weight:600;color:#0f172a;">{{ app_currency.symbol }}{{ rev.total }}</td>
            <td style="padding:8px 10px;text-align:center;">
              <StatusBadge :status="rev.status"></StatusBadge>
            </td>
            <td style="padding:8px 10px;color:#64748b;">{{ $formatDate(rev.created_at, 'DD-MM-YYYY') }}</td>
            <td style="padding:8px 10px;text-align:center;">
              <div class="dropdown" v-if="rev.status !== 'superseded'">
                <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ti ti-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li v-if="row.status !== 'dispatched' && row.status !== 'completed'">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_modal" @click="$refs.salesOrderModal.salesOrder(rev.public_token)"><i class="ti ti-edit me-1"></i>Edit</a>
                  </li>
                  <li v-if="(auth?.type === 'ADMIN' || rev.created_by === auth?.id) && !['superseded','completed','cancelled','dispatched','rejected'].includes(rev.status)">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_modal" @click="$refs.salesOrderModal.reviseSalesOrder(rev.public_token)"><i class="ti ti-refresh me-1"></i>Revise Sales Order</a>
                  </li>
                  <li>
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="salesOrderPDF(rev.id)"><i class="ti ti-file-type-pdf me-1"></i>View PDF</a>
                  </li>
                  <li>
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_detail_modal" @click="$refs.salesOrderModal.salesOrderActivity(rev);"><i class="ti ti-list-details me-1"></i>Sales Order Activity</a>
                  </li>
                </ul>
              </div>
              <span v-else style="font-size:11px;color:#94a3b8;font-style:italic;">Revised</span>
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <!-- Empty -->
    <div v-else style="text-align:center;padding:16px;color:#94a3b8;font-size:12px;">
      <i class="ti ti-versions-off" style="font-size:16px;"></i> No revisions for this sales order.
    </div>

  </div>
</template>
  </app-table>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<sales-order-modal
  ref="salesOrderModal"
  @updated="loadAll"
  @approve-after-save="approveAfterSave"
  @reject-after-save="rejectAfterSave"
  @open-update-status="openUpdateStatusFromQC">
</sales-order-modal>
<store-dispatch-item-modal ref="storeDispatchItemModal" @updated="loadAll"></store-dispatch-item-modal>

<div class="modal fade" id="order_detail_modal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="ti ti-file-description me-2"></i>
          Order Detail — {{ selectedOrderDetail?.so_number }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body" v-if="selectedOrderDetail">

        <!-- Items Table -->
<!-- ── Items Table (original, simple) ── -->
<h6 class="fw-semibold mb-3"><i class="ti ti-list me-1"></i>Items</h6>
<div class="table-responsive mb-4">
  <table class="table table-bordered table-sm align-middle">
    <thead class="table-light">
      <tr>
        <th style="width:40px;">#</th>
        <th>Name</th>
        <th style="width:80px;">Unit</th>
        <th style="width:70px;">Qty</th>
        <th style="width:70px;">Size</th>
        <th style="width:80px;">Width</th>
        <th style="width:80px;">Height</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(item, index) in selectedOrderDetail.sales_order_items" :key="item.id">
        <template v-if="item.dimensions && item.dimensions.length">
          <tr v-for="(dim, dIndex) in item.dimensions" :key="`${item.id}-${dIndex}`">
            <td v-if="dIndex === 0" :rowspan="item.dimensions.length" class="fw-semibold text-center">
              {{ index + 1 }}
            </td>
            <td v-if="dIndex === 0" :rowspan="item.dimensions.length">
              {{ item.name }}
              <span v-if="item.dimensions.length > 1" class="badge bg-light text-secondary border ms-1" style="font-size:10px;">
                {{ item.dimensions.length }} sizes
              </span>
            </td>
            <td v-if="dIndex === 0" :rowspan="item.dimensions.length">{{ item.unit }}</td>
            <td class="text-center">{{ dim.quantity }}</td>
            <td class="text-center">{{ dim.size ? parseFloat(dim.size).toFixed(2) : 'NA' }}</td>
            <td class="text-center">{{ dim.width || 'NA' }}</td>
            <td class="text-center">{{ dim.height || 'NA' }}</td>
          </tr>
        </template>
        <tr v-else>
          <td class="fw-semibold text-center">{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.unit }}</td>
          <td class="text-center">{{ item.quantity }}</td>
          <td class="text-center">{{ item.size ? parseFloat(item.size).toFixed(2) : 'NA' }}</td>
          <td class="text-center">{{ item.width || 'NA' }}</td>
          <td class="text-center">{{ item.height || 'NA' }}</td>
        </tr>
      </template>
    </tbody>
  </table>
</div>

<!-- ── Drawing Dimensions (alag section) ── -->
<template v-if="hasAnyDimensions">
  <h6 class="fw-semibold mb-3"><i class="ti ti-ruler-2 me-1"></i>Drawing Dimensions</h6>
  <div class="table-responsive mb-4">
    <table class="table table-bordered table-sm align-middle">
  <thead class="table-light">
    <tr>
      <th style="width:40px;">#</th>
      <th>Item</th>
      <th style="width:80px;">Width</th>
      <th style="width:80px;">Height</th>
      <th style="width:100px;">Drawing<br>Width</th>
      <th style="width:100px;">Drawing<br>Height</th>
      <th style="width:100px;">Drawing<br>Qty</th>
      <th v-if="auth?.role?.is_sales_order_drawing" style="width:70px;" class="text-center">Action</th>
    </tr>
  </thead>
  <tbody>
    <template v-for="(item, index) in selectedOrderDetail.sales_order_items" :key="item.id">
      <template v-if="item.dimensions && item.dimensions.length">
        <tr v-for="(dim, dIndex) in item.dimensions" :key="`dd-${item.id}-${dIndex}`">
          <td class="text-center">{{ index + 1 }}<span v-if="item.dimensions.length > 1">.{{ dIndex + 1 }}</span></td>
          <td>{{ item.name }}</td>
          <td class="text-center">{{ dim.width || 'NA' }}</td>
          <td class="text-center">{{ dim.height || 'NA' }}</td>
          <td class="text-center" :class="dim.drawing_width ? 'text-success fw-semibold' : 'text-muted'">
            {{ dim.drawing_width || '—' }}
          </td>
          <td class="text-center" :class="dim.drawing_height ? 'text-success fw-semibold' : 'text-muted'">
            {{ dim.drawing_height || '—' }}
          </td>
          <td class="text-center" :class="dim.drawing_quantity ? 'text-success fw-semibold' : 'text-muted'">
            {{ dim.drawing_quantity || '—' }}
          </td>
          <td v-if="auth?.role?.is_sales_order_drawing" class="text-center">
            <button type="button" class="btn btn-sm btn-icon rounded-circle"
              :class="dim.drawing_width ? 'btn-light-success' : 'btn-light-primary'"
              :title="dim.drawing_width ? 'Edit drawing dimension' : 'Add drawing dimension'"
              @click="openDrawingDimensionModal(item, dim)">
              <i :class="dim.drawing_width ? 'ti ti-edit' : 'ti ti-ruler-2'"></i>
            </button>
          </td>
        </tr>
      </template>
    </template>
  </tbody>
</table>
  </div>
</template>

        <!-- Documents -->  
      <h6 class="fw-semibold mb-3"><i class="ti ti-photo me-1"></i>Documents</h6>
      <div class="row g-3" v-if="selectedOrderDetail.documents?.length">
        <div class="col-md-4" v-for="doc in selectedOrderDetail.documents" :key="doc.id">
          <a :href="doc.document_url" target="_blank">
            <template v-if="doc.file_type && doc.file_type.startsWith('image/')">
              <img :src="doc.document_url" class="img-fluid rounded border" style="max-height: 200px; object-fit: cover; width: 100%;" />
            </template>
            <template v-else>
              <div class="border rounded p-3 text-center">
                <i class="ti ti-file-type-pdf fs-1 text-danger" v-if="doc.file_type === 'application/pdf'"></i>
                <i class="ti ti-file fs-1 text-muted" v-else></i>
                <p class="mb-0 mt-2 fs-12 text-truncate">{{ doc.document_type || 'Document' }}</p>
              </div>
            </template>
          </a>
        </div>
      </div>
      <p v-else class="text-muted">No documents uploaded.</p>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>


<!-- Drawing Dimension Modal -->
<div class="modal fade" id="drawing_dimension_modal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
      <div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
        <h5 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">
          <i class="ti ti-ruler-2 me-1"></i>Drawing Dimension — {{ currentItemName }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <form @submit.prevent="saveDrawingDimension">
        <div class="modal-body" style="padding:18px;">
          <div class="mb-3">
            <label class="form-label fw-semibold">Drawing Width (mm)</label>
            <input type="number" class="form-control" v-model.number="drawingDimensionForm.drawing_width" placeholder="Enter drawing width" />
          </div>
          <div class="mb-3">
            <label class="form-label fw-semibold">Drawing Height (mm)</label>
            <input type="number" class="form-control" v-model.number="drawingDimensionForm.drawing_height" placeholder="Enter drawing height" />
          </div>
          <div class="mb-3">
            <label class="form-label fw-semibold">Drawing Quantity</label>
            <input type="number" class="form-control" v-model.number="drawingDimensionForm.drawing_quantity" placeholder="Enter drawing quantity" />
          </div>
        </div>
        <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 18px;gap:8px;">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-primary">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>


<invoice-modal ref="invoiceModal" @updated="loadAll"></invoice-modal>

<delivery-challan-modal ref="challanModal" @updated="loadAll"></delivery-challan-modal>

</template>

<style scoped>
.table-responsive {
  overflow-y: auto;
}
</style>